import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getUploadAudioUrlForConversationMsg = (
  conversationId,
  messageId,
  contentType,
  callback,
  errCb,
) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_UPLOAD_URL_FOR_CONVERSATION_MESSAGE' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/cs/conversation/${conversationId}/message/${messageId}`,
            null,
            {
              params: {
                'request-id': reqId,
                contentType,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'x-api-version': 'v1',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_UPLOAD_URL_FOR_CONVERSATION_MESSAGE_DONE',
              payload: {
                response: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_UPLOAD_URL_FOR_CONVERSATION_MESSAGE_FAILED',
              payload: `Failed to get upload url`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_UPLOAD_URL_FOR_CONVERSATION_MESSAGE_FAILED',
            payload: `Failed to get upload url`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_UPLOAD_URL_FOR_CONVERSATION_MESSAGE_FAILED',
        payload: `Failed to get upload url`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default getUploadAudioUrlForConversationMsg;
